import { fetchAllCurves, create, remove } from 'api/curve';
import { REQUEST_SUCCESS, REQUEST_FAIL } from 'reducers/modal/actions';

const externallyManagedEdevs =
  window.env.REACT_APP_EXTERNALLY_MANAGED_EDEVS === 'true';

export const GET_ALL_CURVES_SUCCESS = 'GET_ALL_CURVES_SUCCESS';
export const GET_ALL_CURVES_FAIL = 'GET_ALL_CURVES_FAIL';
export const CREATE_CURVE_SUCCESS = 'CREATE_CURVE_SUCCESS';
export const CREATE_CURVE_FAIL = 'CREATE_CURVE_FAIL';
export const DELETE_CURVE_SUCCESS = 'DELETE_CURVE_SUCCESS';
export const DELETE_CURVE_FAIL = 'DELETE_CURVE_FAIL';
export const SET_CURVES_SUCCESS = 'SET_CURVES_SUCCESS';
export const SET_CURVES_FAILURE = 'SET_CURVES_FAILURE';
export const SET_INDIVIDUAL_CURVE_SUCCESS = 'SET_INDIVIDUAL_CURVE_SUCCESS';
export const SET_INDIVIDUAL_CURVE_FAIL = 'SET_INDIVIDUAL_CURVE_FAIL';

export const getAllCurves = () => async dispatch => {
  try {
    const curves = await fetchAllCurves();
    return dispatch({
      type: GET_ALL_CURVES_SUCCESS,
      data: curves
    });
  } catch (err) {
    // Redundant catch-throw, but maintaining this until we update polling
    throw err;
  }
};

export const duplicateCurve = curveId => async (dispatch, getState) => {
  try {
    dispatch({
      type: REQUEST_FAIL,
      message: `Curve with ID ${curveId} already exists`
    });
  } catch (err) {
    return dispatch({
      type: CREATE_CURVE_FAIL,
      err
    });
  }
};

export const createCurve = curve => async (dispatch, getState) => {
  try {
    await create(curve);
    const allCurves = getState().curve.curves;
    let newCurves = allCurves.slice();
    if (newCurves.length) {
      const newCurve = { ...curve };
      if (externallyManagedEdevs) {
        newCurve.localCurve = true;
      }
      newCurves.push(newCurve);
    } else {
      newCurves = await fetchAllCurves();
    }
    dispatch({
      type: REQUEST_SUCCESS,
      message: `Curve ${curve.curveId} create success`
    });
    dispatch({
      type: CREATE_CURVE_SUCCESS,
      data: newCurves
    });
    return { curveId: curve.curveId };
  } catch (err) {
    dispatch({
      type: REQUEST_FAIL,
      message: `Curve ${curve.curveId} create failed`
    });
    throw err;
  }
};

export const deleteCurve = curveId => async (dispatch, getState) => {
  try {
    const allCurves = getState().curve.curves;
    await remove(curveId);
    const updatedCurves = allCurves.filter(curve => {
      return curve.curveId !== curveId;
    });
    dispatch({
      type: REQUEST_SUCCESS,
      message: `Curve ${curveId} delete success`
    });
    return dispatch({
      type: DELETE_CURVE_SUCCESS,
      data: updatedCurves
    });
  } catch (err) {
    dispatch({
      type: REQUEST_FAIL,
      message: `Curve ${curveId} delete failed`
    });
    throw err;
  }
};

export const setCurves = curves => async (dispatch, getState) => {
  try {
    await dispatch({
      type: SET_CURVES_SUCCESS,
      data: curves
    });
    return curves;
  } catch (err) {
    // Redundant catch-throw, but maintaining this until we update polling
    throw err;
  }
};

export const setIndividualCurve =
  individualCurve => async (dispatch, getState) => {
    try {
      const curves = getState().curve.curves;
      const updatedCurves = curves.map(curve => {
        if (curve.curveId === individualCurve.curveId) {
          return individualCurve;
        }
        return curve;
      });
      await dispatch({
        type: SET_INDIVIDUAL_CURVE_SUCCESS,
        data: updatedCurves
      });
      return;
    } catch (err) {
      // Redundant catch-throw, but maintaining this until we update polling
      throw err;
    }
  };
